import { AfterViewInit, ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropDownFilterSettings, MultiSelectComponent, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'pxd-ag-grid-multi-select-editor',
  template: `<kendo-multiselect #selectControl [filterable]="true"
                             [kendoDropDownFilter]="filterSettings" [readonly]="readonly"
                             [clearButton]="clearButton" style="width:100%" [data]="dropdownData"  [virtual]="virtual" [listHeight]="listHeight"
                             textField="text" [popupSettings]="popupSettings" valueField="value" [valuePrimitive]="true" [(ngModel)]="value">
            </kendo-multiselect>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    MultiSelectModule,
  ],
})

export class PxdAgGridMultiSelectEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public popupSettings: any = {
    width: 150,
  };

  public listHeight: number = 200;

  public dropdownData: any;
  public value: any;
  public clearButton: boolean;
  public onChange: Event;
  public readonly: boolean = false;

  public virtual: any = {
    itemHeight: 28,
  };

  private readonly selectControl = viewChild<MultiSelectComponent>('selectControl');

  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };

  private onValueChange: (data: any) => void;

  public agInit(params: any): void {
    this.value = params.value;
    this.dropdownData = params.values;
    this.clearButton = true;
    this.readonly = params.readonly;
    if (params.popupHeight) {
      this.popupSettings.height = params.popupHeight;
      this.listHeight = params.popupHeight;
    }
    if (params.popupWidth) {
      this.popupSettings.width = params.popupWidth;
    }
    this.onValueChange = params.onValueChange;
  }

  public ngAfterViewInit(): void {
    if (this.onValueChange) {
      this.selectControl().valueChange.subscribe((data) => {
        this.onValueChange(data);
      });
    }
  }

  public getValue(): any {
    return this.value;
  }
}